import React from "react"
import PropTypes from "prop-types"
import Section from "components/Section"
import Color from "components/Color"
import Typography from "@material-ui/core/Typography"
import { withStyles } from "@material-ui/core/styles"

const styles = theme => ({
	colors: {
		margin: theme.spacing ( -2 ),
		marginTop: theme.spacing ( 2 ),
		display: "flex",
		flexWrap: "wrap",
		justifyContent: "space-between"
	}
})

class ColorsSection extends React.Component {

	render () {
		const { classes, theme } = this.props
		const elements = Object.keys ( theme.palette )
			.filter ( e =>
				theme.palette [ e ].constructor.name === "Object" &&
				"main" in theme.palette [ e ]
			)
		return <Section id="colors" >
			<Typography variant="h5" >Colors</Typography>
			<div className={classes.colors} >
			{
				elements.map ( name => <Color key={name} name={name} /> )
			}
			</div>
		</Section>
	}

}

ColorsSection.propTypes = {
	classes: PropTypes.object.isRequired
}

export default withStyles ( styles, { withTheme: true } ) ( ColorsSection )
